import React, { FunctionComponent } from "react";

export const MoreVertical: FunctionComponent = () => (
  <svg width="3" height="10" viewBox="0 0 3 10" fill="#373F51" xmlns="http://www.w3.org/2000/svg">
    <circle cx="1.17578" cy="1" r="1" />
    <circle cx="1.17578" cy="5" r="1" />
    <circle cx="1.17578" cy="9" r="1" />
  </svg>
);
